import { msg } from '@lingui/core/macro';

import Alarms from './alarms';
import Devices from './devices';
import devicesRoutes from './devices/routes'
import Settings from './settings';
import settingsRoutes from './settings/routes';
import GetStarted from './get-started';
import NotFound from './404';
import { restrictRoute } from 'components/protected-route';


export default [
  {
    id: 'login',
    name: 'Log In',
    trans: msg`Log In`,
    path: 'login',
    Component: () => {}, // No-op. The actual rendering of login is handled in App.jsx
    hideFromNav: true
  },
  restrictRoute({
    id: 'alarms',
    name: 'Alarms',
    // Since this is processed on compile time we
    // need to tell Lingui to index it. Then we can
    // use it like <Trans>{_(route.trans)}</Trans>
    trans: msg`Alarms`,
    path: 'alarms',
    access: ['CanAccessOverview'],
    Component: Alarms,
  }),
  restrictRoute({
    id: 'devices',
    name: 'Devices',
    trans: msg`Devices`,
    path: 'devices',
    access: ['CanAccessMonitoring'],
    Component: Devices,
    children: devicesRoutes
  }),
  {
    id: 'settings',
    name: 'Settings',
    trans: msg`Settings`,
    path: 'settings',
    Component: Settings,
    children: settingsRoutes
  },
  {
    id: 'get-started',
    name: 'Get Started',
    trans: msg`Get Started`,
    path: 'get-started',
    Component: GetStarted,
    hideFromNav: true
  },
  {
    id: '404',
    name: '404',
    path: '*',
    Component: NotFound,
    hideFromNav: true
  }
];
